import axios from "axios";
import { url } from "./utils/url";
import authHeader from "./utils/auth-header";

class EventApi {
  static async getAll() {
    const result = await axios.get(`${url}/admin/events`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async getOne(id: any) {
    const result = await axios.get(`${url}/admin/events/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async getOneBoth(id: any) {
    const result = await axios.get(`${url}/admin/events/${id}/both`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async delete(id: any) {
    const result = await axios.delete(`${url}/admin/events/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async deletePrice(id: any) {
    const result = await axios.delete(`${url}/admin/events/price/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async create(body: any) {
    const result = await axios.post(`${url}/admin/events`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async update(id: any, body: any) {
    const result = await axios.put(`${url}/admin/events/${id}`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async upload(body: any) {
    const result = await axios.post(`${url}/admin/events/photo/upload`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async deleteImage(id: any) {
    const result = await axios.delete(`${url}/admin/events/image/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async deleteImageSource(body: any) {
    const result = await axios.post(`${url}/admin/events/imageSource`, body, {
      headers: authHeader(),
    });

    return result.data;
  }
}

export default EventApi;
